"use client";

import type { IconWeight } from "@phosphor-icons/react/dist/lib/types";
import * as icons from "@phosphor-icons/react/dist/ssr";
import type { HTMLAttributes } from "react";

import { customIcons } from "./custom";

type CustomIconName = keyof typeof customIcons;

type PhosphorIconName = Exclude<
  keyof typeof icons,
  "IconContext" | "IconBase" | "SSR"
>;

export type IconName = CustomIconName | PhosphorIconName;

type IconProps = {
  name: IconName;
  weight?: IconWeight;
  size?: string;
} & Omit<HTMLAttributes<SVGElement>, "color">;

const DefaultIcon = icons.QuestionIcon || (() => null);

export function Icon({
  name,
  weight = "regular",
  size = "1em",
  ...rest
}: IconProps) {
  const Comp =
    customIcons[name as CustomIconName] || icons[name as PhosphorIconName];

  if (!Comp) {
    console.error(`Icon "${name}" not found. Falling back to DefaultIcon.`);
    return (
      <DefaultIcon {...rest} size="1em" fill="currentColor" weight={weight} />
    );
  }

  return <Comp {...rest} size={size} fill="currentColor" weight={weight} />;
}
